import { render, staticRenderFns } from "./nice-pay-u.vue?vue&type=template&id=398ef429&"
import script from "./nice-pay-u.vue?vue&type=script&lang=js&"
export * from "./nice-pay-u.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports